import React, { useEffect, useState } from 'react';
import PropTypes, { shape, objectOf } from 'prop-types';
import OnboardingSlideshow from 'components/OnboardingSlideshow/OnboardingSlideshow';
import clsx from 'clsx';
import GTMTracker from 'tracking/gtm-tracker';
import styles from './LoadingScreen.module.scss';

const LoadingScreen = ({
  progressPercent = 0,
  preloadEnd = false,
  onComplete,
  data,
}) => {
  const [, setProgressLabel] = useState('loading');
  const [animateToTransition, setAnimateToTransition] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  useEffect(() => {
    console.log('LOADER ');
  }, []);

  useEffect(() => {
    if (!preloadEnd) {
      return;
    }

    // setFadeOut(true);
    const to = setTimeout(() => {
      clearTimeout(to);
    }, 600);
    return () => {
      clearTimeout(to);
    };
  }, [onComplete, preloadEnd]);

  useEffect(() => {
    if (progress >= 1 && !isComplete) {
      setProgressLabel('Loading');
      setIsComplete(true);
      const to1 = setTimeout(() => {
        clearTimeout(to1);
        setAnimateToTransition(true);
      }, 500);

      const to = setTimeout(() => {
        clearTimeout(to);
        GTMTracker.push('Loading', 'StartXperience');
        onComplete();
      }, 2700);
    }
  }, [onComplete, progress]);

  useEffect(() => {
    setProgress(progressPercent);
  }, [progressPercent]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.logo} />
      <div className={styles.onboarding}>
        <OnboardingSlideshow intro loadingComplete={false} />
      </div>
      <div
        className={clsx(styles.progress, {
          [styles.fillScreen]: animateToTransition,
        })}
      >
        <div className={styles.barWrapper}>
          <div
            className={styles.bar}
            style={{ width: `${Math.round(progress * 100)}%` }}
          />
          <span className={styles.barLabel}>
            {data.playcanvasData.mainData.overallApp.loadingText}
          </span>
        </div>
      </div>
    </div>
  );
};

LoadingScreen.propTypes = {
  progressPercent: PropTypes.number.isRequired,
  preloadEnd: PropTypes.bool.isRequired,
  onComplete: PropTypes.func.isRequired,
  data: objectOf(shape).isRequired,
};

export default LoadingScreen;
